import { Component, Injector, OnInit, ElementRef, ViewChild, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppConstants } from '@app/@core/entities/app-constants';
import { SocketAdapterService } from '@app/@core/services/socket-adapter.server';
import { AuthState } from '@core/auth/auth.models';
import { selectAuth } from '@core/auth/auth.selectors';
import { AppState } from '@core/core.state';
import { AlertService } from '@core/services/alert.service';
import { AuthService } from '@core/services/auth.service';
import { LocalService } from '@core/services/local.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { ReCaptcha2Component } from 'ngx-captcha';
import { environment } from '@env/environment';

interface City {
  name: string;
  code: string;
}

@Component({
    selector: 'app-login-no-captcha',
    templateUrl: './login-no-captcha.component.html',
    styleUrls: ['./login-no-captcha.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class LoginNoCaptchaModuleComponent implements OnInit, AfterViewInit,OnDestroy {
  @ViewChild('showhideinput') input;
  @ViewChild('ngOtpInput') ngOtpInputRef;
  value3!: string;
  cities: City[] = [];
  selectedCity1!: City;
  loginForm!: FormGroup;
  passwordForm!: FormGroup;
  otpForm!: FormGroup;
  show!: boolean;
  disabledLoginPage!: boolean;
  submitStatus!: string;
  submitSecretStatus!: string;
  errorStatus?: string;
  closeResult = '';
  isAuthenticated$!: Observable<AuthState>;
  localstorage: LocalService;
  isOtpSent: boolean;
  socketAdapter: SocketAdapterService;
  sessionKey!: string;
  recaptchaSiteKey: string;
  recaptchaToken: string;
  isTimerDone: boolean = false;
  time: string;
  count: any;
  visible: boolean = false;
  showLanguage: boolean = false;
  isMailOtp: boolean = false;
  loginPass: boolean = false;

  /* Google re-captcha onfiguration section  Starts */
  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component;
  @ViewChild('langInput') langInput: ElementRef;

  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaIsExpired = false;
  public captchaResponse?: string;


  public theme: 'light' | 'dark' = 'light';
  public size: 'compact' | 'normal' = 'normal';
  public lang = 'en';
  public type: 'image' | 'audio';
  /* Google re-captcha onfiguration section  - Ends */


  constructor(
    injector: Injector,
    private store$: Store<AppState>,
    private _router: Router,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private alertService: AlertService,
    private authService: AuthService,
    private renderer: Renderer2
  ) {
    this.localstorage = injector.get<LocalService>(LocalService);
    this.socketAdapter = injector.get<SocketAdapterService>(SocketAdapterService)
    this.submitStatus = 'Submit';
    this.disabledLoginPage = false;
    this.recaptchaSiteKey = environment.recaptchaSiteKey;
    this.renderer.addClass(document.body, 'clsRemoveTranslate');
  }
  ngAfterViewInit(): void {
    var eles = document.getElementsByClassName('otp-input');
    for (var i = 0; i < eles.length; i++) {
      eles[i].setAttribute('aria-label', 'slide-dot')
    }
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'clsRemoveTranslate');
  }

  ngOnInit(): void {
    this.showLanguage = sessionStorage.getItem('showLanguage') == 'false' ? false : true;
    sessionStorage.clear();
    localStorage.clear();
    this.initializeForm();
    this.isAuthenticated$ = this.store$.pipe(select(selectAuth));
    this.isAuthenticated$.subscribe(
     {next: res => {
        if (res.isAuthenticated) {
          const routeToAdmin = res.pages.some(a => a.name === 'Application Management');
          if (routeToAdmin) {
            this._router.navigate(['/pages/rbac']);
          } else {
            this._router.navigate(['/pages/page-design/list']);
          }
        }
      },
      error:(err) => {
        console.log(err);

        if (err.error) {
          if (err?.error?.errors?.code === 'NotAuthorizedException' || err?.error?.errors?.email === 'notFound') {
            this.alertService.error('Invalid Credentials.');
          } else this.alertService.error('System Error, Please try after sometime.');
        }
        this.submitStatus = 'Submit';
        this.submitSecretStatus = 'Submit';
      }
   }
    );
  }

  timer(minute) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 30;

    const prefix = minute < 10 ? "0" : "";

    this.count = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.time = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        this.isTimerDone = true;
        clearInterval(this.count);
        this.time = ''
      }
    }, 1000);
  }

  initializeForm() {
    // for now remove validation recaptcha (Validators.required)
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(AppConstants.regexLoginEmail)]],
      recaptcha: ['']
    });
    this.passwordForm = this.fb.group({
      password: ['', Validators.required],
      conditions: ['', Validators.required],
    });


  }
  initializeOtpForm() {
    this.otpForm = this.fb.group({
      otp: ['', [Validators.minLength(6), Validators.required]]
    });
  }
  open(content) {
    this.modalService.open(content, { size: 'lg', backdrop: 'static' }).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  async handleSuccess(data) {
    console.log(data);
    this.recaptchaToken = data;
  }

  login(action: string, otp?: string) {
    this.submitStatus = 'Please wait ...';
    this.submitSecretStatus = 'Please wait ...';
    this.errorStatus = '';
    const loginForm = this.loginForm.getRawValue();
    const passwordForm = this.passwordForm.getRawValue();
    let isInvalidOTP = false;
    if (action === 'login') {
      this.authService.validateMail({ email: loginForm.email.trim(), recaptchaToken: this.recaptchaToken, isWeb: true}).subscribe(
      {next: (res: any) => {
          if (res?.data?.firstlogin?.length) {
            this._router.navigate(['/auth/change-password'], { queryParams: { isTempPassword: 'TEMP_PASSWORD_RESET', email: loginForm.email.trim() } });
          } else {
            this.submitSecretStatus = 'Login';
            this.submitStatus = 'Login';
            this.loginPass = true;
          }
        },
        error:(error) => {
          if (error.error) {
            if (error?.error?.message) {
              this.alertService.error(error?.error?.message)
            } else if (error?.error?.errors) {
              this.alertService.error(error?.error?.errors)
            } else {
              this.alertService.error(AppConstants.errorMessage);
            }            
            this.submitStatus = 'Submit';
            this.submitSecretStatus = 'Submit';
            this.captchaElem.resetCaptcha();
          }
        }
     }
      );
    } else if(this.isTimerDone && action !=='resend'){
      this.alertService.error('OTP expired.');
      this.submitSecretStatus = 'Submit';
    } else {
      this.authService.login(loginForm.email.trim(), passwordForm.password.trim(), otp, this.sessionKey).subscribe(
         {next:(res: any) => {
          if (res) {
            if (res.mfamode && res.mfamode == "SMS") {
              this.isMailOtp = false;
            }
            else if (res.mfamode && res.mfamode == "EMAIL") {
              this.isMailOtp = true;
            }
            if (res === 'MFA_CODE_SEND' || res?.challengeParameters?.OTP === 'Enter OTP sent to Email') {
              this.sessionKey = res.session;
              if (otp) {
                this.alertService.error(AppConstants.invalidOTP);
                isInvalidOTP = true;
                this.ngOtpInputRef.setValue(null);
              }
              if (action == 'otp' && isInvalidOTP) {
                this.isOtpSent = true;
                this.submitSecretStatus = 'Submit';
                return;
              } else if (action == 'resend') {
                clearInterval(this.count);
                this.time = null
                this.isTimerDone = false;
                this.ngOtpInputRef.setValue(null);
                this.alertService.success(AppConstants.resendOTP);
              }
              this.isOtpSent = true;
              this.initializeOtpForm();
              this.submitSecretStatus = 'Submit';
              this.timer(1.5);
              return;
            }
            this.socketAdapter.connect();
            if (res?.action === 'TEMP_PASSWORD_RESET') {
              this._router.navigate(['/auth/change-password'], { queryParams: { isTempPassword: res?.action === 'TEMP_PASSWORD_RESET', email: loginForm.email.trim() } });
            } else {
              this.authService.getLoggedInUserInfo();
            }
          }
        },
        error:(error) => {
          if (error.error) {
            if (error?.error?.message) {
              if (error?.error?.message === 'OTP retry attempt exceeded.') {
                this.onCancel();
                this.alertService.error('OTP retry attempt exceeded.');
              } else {
                this.alertService.error(error?.error?.message);
              }
            } else if (error?.error?.errors) {
              this.alertService.error(error?.error?.errors)
            } else {
              this.alertService.error(AppConstants.errorMessage);
            }
            this.submitStatus = 'Login';
            this.ngOtpInputRef.setValue(null);
            this.submitSecretStatus = 'Submit';
          }
          if (error?.error?.message.toLowerCase() == "otp retry attempt exceeded.") {
            this.submitSecretStatus = 'Submit';
            this.ngOtpInputRef.setValue(null);
          } else {
            this.submitStatus = 'Login';
          }
          this.captchaElem.resetCaptcha();
        }}
      );
    }
  }

  sendOtp() {
    const otpFormDetails = this.otpForm.getRawValue();
    this.login('otp', otpFormDetails.otp);
  }

  toggleShow() {
    this.show = !this.show;
    if (this.show) {
      this.input.nativeElement.type = 'text';
    } else {
      this.input.nativeElement.type = 'password';
    }
  }

  routeToChangePassword() {
    this._router.navigate(['/auth/forgot-password']);
  }



  // routeToDynamicPage(landingPage: any) {
  //   const orgid = sessionStorage.getItem('orgid');
  //   if (landingPage.route.includes('dynamic-search/search')) {
  //     const pageId = landingPage.route.split('/')[4];
  //     if (pageId) {
  //       this.authService.checkDynamicPagePermission(pageId);
  //     } else {
  //       this.authService.routeToDynamicPage(orgid).subscribe(res => {
  //         if (res && res.data.length) {
  //           const authorisedPages = res?.data?.filter(a => a?.activeVersion?.gridconfig);
  //           this.localstorage.setItem('selectedDynamicPage', authorisedPages[0]?.activeVersion?.id);
  //           if (authorisedPages && authorisedPages.length && authorisedPages[0]?.activeVersion?.gridconfig) {
  //             const gridPageRoute = `pages/dynamic-search/search/${authorisedPages[0]?.activeVersion?.id}`;
  //             this._router.navigate([gridPageRoute]);
  //             this.localstorage.setItem('dashboardRoute', gridPageRoute);
  //           }
  //         } else {
  //           this.alertService.error(
  //             'You don\'t have permissions to perform the following operations .Please Contact Administrator'
  //           );
  //         }
  //       });
  //     }
  //   } else {
  //     const landingPageRoute = `pages${landingPage?.route}`;
  //     this._router.navigate([landingPageRoute]);
  //     this.localstorage.setItem('dashboardRoute', landingPageRoute);
  //   }
  // } 

  onCancel() {
    sessionStorage.clear();
    this.loginForm?.reset();
    this.otpForm?.reset();
    this.passwordForm?.reset();
    this.isOtpSent = false;
    this.submitStatus = 'Submit';
    this.submitSecretStatus = 'Submit';
    this.sessionKey = null;
    clearInterval(this.count);
    this.time = null
    this.isTimerDone = false;
    this.loginPass = false;
    if (this.captchaElem) {
      this.captchaElem.resetCaptcha();
    }
    this.initializeForm();
  }

  onResend() {
    this.login('resend');
  }

  patchOTP(value: string) {
    this.otpForm.patchValue({ otp: value })
  }

  showLanguageDialog() {
    this.visible = true;
  }

  acceptLanguage() {
    this.visible = false;
    this.showLanguage = false;
    sessionStorage.setItem('showLanguage', "");
    sessionStorage.setItem('showLanguagePage', "false");
    let googleTranElement = document.getElementById('google_translate_element');
    googleTranElement.className = 'clsLangTrans';
  }
}
